import { ErrorHandler, inject, Injectable, NgZone } from '@angular/core';
import { MessageService } from 'primeng/api';
import { I18n } from '@/app/core/i18n/i18n';

/** Surfaces uncaught client errors as a Serbian toast (HTTP/GraphQL errors are handled in the Apollo error link). */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private readonly messages = inject(MessageService);
    private readonly zone = inject(NgZone);
    private readonly i18n = inject(I18n);

    handleError(error: unknown): void {
        // eslint-disable-next-line no-console
        console.error(error);
        this.zone.run(() => this.messages.add({ severity: 'error', summary: this.i18n.t('feedback.unexpectedSummary'), detail: this.i18n.t('feedback.unexpectedDetail') }));
    }
}
